import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-24 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight">
          {t('cta.title')}
        </h2>
        <p className="mt-5 text-base md:text-lg text-foreground-500 leading-relaxed">
          {t('cta.subtitle')}
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-4 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            <span>{t('cta.button')}</span>
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-4 rounded-full border-2 border-foreground-200 text-foreground-700 text-sm font-semibold hover:border-foreground-900 hover:text-foreground-900 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            <span>{t('hero.cta_sheet')}</span>
            <i className="ri-external-link-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-center gap-4 md:gap-6">
          {[
            { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
            { name: 'Hoodies', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
            { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
            { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
            { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
            { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
          ].map((item) => (
            <a
              key={item.name}
              href={item.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex items-center gap-2 px-4 py-2 rounded-full bg-background-50 border border-background-300 text-sm text-foreground-600 hover:border-accent-400 hover:text-accent-600 transition-all cursor-pointer whitespace-nowrap"
            >
              <span>{item.name}</span>
              <i className="ri-arrow-right-up-line w-3.5 h-3.5 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}